/**
 * Reservation payment amount values
 */
export enum ReservationPaymentAmountEnum {
	/**
	 * Card validation only with zero amount pre-authorization.
	 */
	NONE = 'none',

	/**
	 * Charge deposit amount based on vehicle category.
	 */
	DEPOSIT = 'deposit',

	/**
	 * Charge full reservation amount.
	 */
	FULL_AMOUNT = 'full_amount',
}
